import { QuickQuestionOption } from '@gelato-api-ui/core/quick-questions/constants/quck-question-option';

export const EcommercePlatformOptions: QuickQuestionOption[] = [
  { id: 'shopify', name: 'Shopify', image: 'e-commerce-stores/48x48/shopify.svg' },
  { id: 'etsy', name: 'Etsy', image: 'e-commerce-stores/48x48/etsy.svg' },
  { id: 'amazon', name: 'Amazon', image: 'e-commerce-stores/48x48/amazon.svg' },
  { id: 'woocommerce', name: 'WooCommerce', image: 'e-commerce-stores/48x48/woo.svg' },
  { id: 'wix', name: 'Wix', image: 'e-commerce-stores/48x48/wix.svg' },
  { id: 'redbubble', name: 'Redbubble', image: 'e-commerce-stores/48x48/redbubble.svg' },
  { id: 'eBay', name: 'eBay', image: 'e-commerce-stores/48x48/ebay.svg' },
  { id: 'squarespace', name: 'Squarespace', image: 'e-commerce-stores/48x48/squarespace.svg' },
  { id: 'ecwid', name: 'Ecwid', image: 'e-commerce-stores/48x48/ecwid.svg' },
  { id: 'weebly', name: 'Weebly', image: 'e-commerce-stores/48x48/weebly.svg' },
  { id: 'bigcommerce', name: 'BigCommerce', image: 'e-commerce-stores/48x48/bigcommerce.svg' },
  { id: '3dcart', name: '3dcart', image: 'e-commerce-stores/48x48/3dcart.svg' },
  { id: 'magento', name: 'Magento', image: 'e-commerce-stores/48x48/magento.svg' },
  { id: 'other', name: 'txt_other_store' },
];
